const MONEY_RE = /^-?\d+(\.\d+)?$/;

export function asMoneyString(value) {
  if (value == null) return "";
  const s = String(value).trim().replace(/,/g, "");
  if (!s || !MONEY_RE.test(s)) return "";
  return s;
}

/** Gross AED for withdraw preview/POST: `^\d+(\.\d{1,2})?$` padded to 2 places. */
export function toAedGrossString(value) {
  const s = String(value ?? "").trim().replace(/,/g, "");
  if (!/^\d+(\.\d{1,2})?$/.test(s)) return "";
  if (/^0+(\.0+)?$/.test(s)) return "";
  const [intRaw, fracRaw = ""] = s.split(".");
  const intPart = intRaw.replace(/^0+(?=\d)/, "") || "0";
  return `${intPart}.${fracRaw.padEnd(2, "0")}`;
}

export function isPositiveMoneyString(value) {
  const s = asMoneyString(value);
  if (!s || s.startsWith("-")) return false;
  return !/^0+(\.0+)?$/.test(s);
}

/** Compare two decimal money strings. Returns -1 | 0 | 1, or null if either invalid. */
export function compareMoney(a, b) {
  const left = asMoneyString(a);
  const right = asMoneyString(b);
  if (!left || !right) return null;
  const negL = left.startsWith("-");
  const negR = right.startsWith("-");
  if (negL !== negR) return negL ? -1 : 1;
  const absL = negL ? left.slice(1) : left;
  const absR = negR ? right.slice(1) : right;
  const [li, lf = ""] = absL.split(".");
  const [ri, rf = ""] = absR.split(".");
  const intL = li.replace(/^0+(?=\d)/, "") || "0";
  const intR = ri.replace(/^0+(?=\d)/, "") || "0";
  if (intL.length !== intR.length) {
    const cmp = intL.length > intR.length ? 1 : -1;
    return negL ? -cmp : cmp;
  }
  if (intL !== intR) {
    const cmp = intL > intR ? 1 : -1;
    return negL ? -cmp : cmp;
  }
  const maxFp = Math.max(lf.length, rf.length);
  const fracL = lf.padEnd(maxFp, "0");
  const fracR = rf.padEnd(maxFp, "0");
  if (fracL === fracR) return 0;
  const cmp = fracL > fracR ? 1 : -1;
  return negL ? -cmp : cmp;
}

export function moneyGreaterThan(a, b) {
  return compareMoney(a, b) === 1;
}

export function newIdempotencyKey(prefix = "fiat") {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `${prefix}-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
